import React, { useState, useEffect } from "react";
import MyProduct from "./MyProduct";
import axios from "axios";
import ReactPaginate from 'react-paginate';

const ItemContractList = ({ handleClick, handleCheck }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [limit] = useState(10);
    const [pages, setPages] = useState(0);
    const [rows, setRows] = useState(0);
    const [keywordserial, setKeywordSerial] = useState("");
    const [queryserial, setQuerySerial] = useState("");
    const [keywordname, setKeywordName] = useState("");
    const [queryname, setQueryName] = useState("");
    const [keywordmanu, setKeywordManu] = useState("");
    const [querymanu, setQueryManu] = useState("");
    const [msg, setMsg] = useState("");
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(
                    `${API_BASE_URL}/products?search_serial=${keywordserial}&search_name=${keywordname}&search_manufacture=${keywordmanu}&page=${page}&limit=${limit}`, {
                        headers: {
                            'X-API-Key': API_KEY
                        },
                    }
                ); 
                setProducts(response.data.result);
                setPage(response.data.page);
                setPages(response.data.totalPage);
                setRows(response.data.totalRows);
            } catch (error) {
                console.error('Error fetching products:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [page, keywordserial, keywordname, keywordmanu]);

    const changePage = ({ selected }) => {
        setPage(selected);
        if (selected === 9) {
        setMsg(
            "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
        );
        } else {
        setMsg("");
        }
    };

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setMsg("");
        setKeywordSerial(queryserial);
        setKeywordName(queryname);
        setKeywordManu(querymanu);
    };


    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="container">
            <div className="column is-8">
              <h1 className="has-text-weight-semibold mb-2">Search Product Add to Ticket:</h1>
              <form onSubmit={searchData}>
                <div className="field has-addons">
                    <div className="control is-expanded">
                        <input
                        type="text"
                        className="input"
                        value={queryname}
                        onChange={(e) => setQueryName(e.target.value)}
                        placeholder="Search by Product Name..." />
                    </div>
                    <div className="control is-expanded">
                        <input
                        type="text"
                        className="input"
                        value={queryserial}
                        onChange={(e) => setQuerySerial(e.target.value)}
                        placeholder="Search by Serial Number..." />
                    </div>
                 
                    <div className="control is-expanded">
                        <input
                        type="text"
                        className="input"
                        value={querymanu}
                        onChange={(e) => setQueryManu(e.target.value)}
                        placeholder="Search by Merek..." />
                    </div>
                    <div className="control">
                        <button type="submit" className="button is-info">
                        Search
                        </button>
                    </div>
                </div>
              </form>
            </div>
            <div className="columns">
              {
                products.map((item) => (
                    <div key={item.uuid} className="column is-3">
                        <MyProduct item={item} handleClick={handleClick} handleCheck={handleCheck} />
                    </div>
                ))                    
                }
            </div>
            <p className="is-size-7">
                Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
            </p>
            <p className="has-text-centered has-text-danger">{msg}</p>
            <nav
                className="pagination is-centered is-size-7"
                key={rows}
                role="navigation"
                aria-label="pagination"
            >
                <ReactPaginate
                breakLabel="..."
                previousLabel={"< Prev"}
                nextLabel={"Next >"}
                pageCount={Math.min(10, pages)}
                onPageChange={changePage}
                containerClassName={"pagination-list"}
                pageLinkClassName={"pagination-link"}
                previousLinkClassName={"pagination-previous"}
                nextLinkClassName={"pagination-next"}
                activeLinkClassName={"pagination-link is-current"}
                disabledLinkClassName={"pagination-link is-disabled"} />
            </nav>
        </div>
    );
};

export default ItemContractList;